import proyecto from "../../api/Proyecto";

export const getChatConversations = async ({ view = "pending", limit = 50 } = {}) => {
  const response = await proyecto.get("/chat/conversations", { params: { view, limit } });
  return response.data;
};

export const getChatMessages = async (idConversation, { limit = 300 } = {}) => {
  const response = await proyecto.get(`/chat/conversations/${idConversation}/messages`, { params: { limit } });
  return response.data;
};

export const claimChatConversation = async (idConversation) => {
  const response = await proyecto.post(`/chat/conversations/${idConversation}/claim`);
  return response.data;
};

export const markChatConversationRead = async (idConversation) => {
  const response = await proyecto.post(`/chat/conversations/${idConversation}/read`);
  return response.data;
};

export const replyChatConversation = async (idConversation, text) => {
  const response = await proyecto.post(`/chat/conversations/${idConversation}/reply`, { text });
  return response.data;
};

export const closeChatConversation = async (idConversation) => {
  const response = await proyecto.post(`/chat/conversations/${idConversation}/close`);
  return response.data;
};

